import { SfModel, SfForm, SfFormSection, SfLink } from '@app/sf-lib/public_api';

export class SomForm extends SfModel implements SfForm {

  public title: string;

  public iconName: string;

  public formSections: SfFormSection[];

  public link: SfLink;

  public popup?: boolean;

  public active: boolean;

  public seoTitle: string;

  public seoDescription: string;

  public channelBellInfo: object;

  public channelFreshInfo: object;

  public constructor() {
    super();
    this.formSections = [];
  }
}
